import { Checkbox, Input, Label } from "@simplicity/ui";
import type { ReactNode } from "react";

/** The SFTP server toggle and its SSH source ranges, shared by the create and edit forms. */
export function ServerFields({
  idPrefix,
  enableSftpServer,
  sshSourceRanges,
  onSftpChange,
  onRangesChange,
  notice,
}: {
  idPrefix: string;
  enableSftpServer: boolean;
  sshSourceRanges: string;
  onSftpChange: (value: boolean) => void;
  onRangesChange: (value: string) => void;
  notice?: ReactNode;
}) {
  return (
    <>
      <div className="mb-4 flex items-center gap-3">
        <Checkbox
          id={`${idPrefix}-sftp`}
          checked={enableSftpServer}
          onCheckedChange={(v) => onSftpChange(v === true)}
        />
        <Label htmlFor={`${idPrefix}-sftp`} className="form-label mb-0">
          SFTP server
        </Label>
      </div>
      {notice}
      <div className="mb-4">
        <Label htmlFor={`${idPrefix}-ranges`} className="form-label">
          SSH source ranges (comma-separated CIDRs)
        </Label>
        <Input
          id={`${idPrefix}-ranges`}
          value={sshSourceRanges}
          onChange={(e) => onRangesChange(e.target.value)}
          className="max-w-sm"
          autoComplete="off"
        />
      </div>
    </>
  );
}
